import { ElementRef, DOCUMENT } from '@angular/core';
import { Router } from '@angular/router';
import { getAllParentElements } from '../dom/get-all-parent-elements';
import { analyzeUrl, UrlType } from '../analyze-url';
import * as i0 from "@angular/core";
import * as i1 from "@angular/router";
/**
 * add support for some basic interaction with angular from inside innerHTML-based templates.
 * Right now it only adds support for directing href/routerLink elements into angular router.
 */
export let InnerHtmlClickHandlerDirective = /*#__PURE__*/(() => {
  class InnerHtmlClickHandlerDirective {
    set _config(config) {
      this.config = {
        ...this.config,
        ...config
      };
    }
    constructor(router, el, doc) {
      this.router = router;
      this.el = el;
      this.doc = doc;
      this.config = {
        interactibleElements: ['A', 'BUTTON'],
        interactibleClasses: [],
        stayOnPage: false
      };
    }
    innerHTMLClick(e) {
      const elements = [e.target, ...getAllParentElements(e.target, this.el.nativeElement)];
      const relevantElement = elements.find(el => {
        if (this.config.isInteractible && this.config.isInteractible(el)) return true;
        if (this.config.interactibleElements.includes(el.tagName)) return true;
        if (this.config.interactibleClasses.some(cls => el.classList.contains(cls))) return true;
        return false;
      });
      if (!relevantElement) {
        // in this case, we can always prevent default action, as html has no interaction by default.
        e.preventDefault();
      } else {
        this.handleInteraction(relevantElement, e);
      }
    }
    handleInteraction(el, e) {
      const hrefAttr = el.attributes.getNamedItem('href');
      const link = hrefAttr ? decodeURI(hrefAttr.value) : null;
      const routerLinkAttr = el.attributes.getNamedItem('routerLink');
      const routerLink = routerLinkAttr ? decodeURI(routerLinkAttr.value) : null;
      let urlInfo = null;
      if (routerLink) {
        urlInfo = {
          type: UrlType.Relative,
          origin: 'routerlink',
          rawUrl: routerLink
        };
      } else if (link) {
        urlInfo = {
          ...analyzeUrl(link),
          origin: 'href',
          rawUrl: link
        };
      }
      if (urlInfo?.type === UrlType.Invalid) return;
      const defaultHandler = () => {
        e.preventDefault();
        e.stopPropagation();
        if (urlInfo.type === UrlType.Hash) {
          this.scrollToAnchor(urlInfo.rawUrl);
        } else if (urlInfo.type === UrlType.Absolute) {
          window.open(urlInfo.rawUrl, '_blank');
        } else if (urlInfo.type === UrlType.CustomProtocol) {
          window.open(urlInfo.rawUrl, '_blank');
        } else {
          if (!this.config.stayOnPage) {
            this.router.navigate([urlInfo.rawUrl]);
          } else {
            const url = this.router.serializeUrl(this.router.createUrlTree([urlInfo.rawUrl]));
            window.open(url, '_blank');
          }
        }
      };
      if (this.config.handler) {
        this.config.handler(urlInfo, el, e, defaultHandler);
      } else {
        defaultHandler();
      }
    }
    scrollToAnchor(elementId) {
      let targetElement = this.el.nativeElement.querySelector(elementId);
      if (!targetElement && this.doc) targetElement = this.doc.querySelector(elementId);
      if (targetElement) {
        targetElement.scrollIntoView({
          behavior: 'auto'
        });
      }
    }
    static {
      this.ɵfac = function InnerHtmlClickHandlerDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || InnerHtmlClickHandlerDirective)(i0.ɵɵdirectiveInject(i1.Router), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(DOCUMENT));
      };
    }
    static {
      this.ɵdir = /*@__PURE__*/i0.ɵɵdefineDirective({
        type: InnerHtmlClickHandlerDirective,
        selectors: [["", "innerHtmlClickHandler", ""]],
        hostBindings: function InnerHtmlClickHandlerDirective_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("click", function InnerHtmlClickHandlerDirective_click_HostBindingHandler($event) {
              return ctx.innerHTMLClick($event);
            });
          }
        },
        inputs: {
          _config: [0, "innerHtmlClickHandler", "_config"]
        }
      });
    }
  }
  return InnerHtmlClickHandlerDirective;
})();